import { v4 } from "uuid";

/**
 * Create a new random UUID
 */
export function generateRandomId(): string {
  return v4();
}
